import React from 'react'
import { Typography } from '@material-ui/core'
import { CampaignType } from '../../../../constants/marketingCampaign'
import { CampaignDefinition } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { Menu } from '../../MarketingCampaigns.promo.services'
import { getOffersFromConfig, getProductDetailsFromConfig } from '../../../../utils/product'
import { normalizeShopIds } from '../../CampaignModalSkeleton/CampaignModalSkeleton.helpers'
import { BogoDiffRuleState } from './types'
import { validateBogoDiffRule } from './validate'
import { buildBogoDiffFormValues } from './buildFormValues'
import { BogoDiffRuleStep } from './RuleStep.view'
import { BogoDiffConfirmationSummary } from './ConfirmationSummary.view'

const ruleDescription = (
	<Typography variant="body2" style={{ color: '#616161', marginBottom: 14, lineHeight: 1.65 }}>
		Construisez des offres où le <strong style={{ color: '#212121' }}>produit acheté</strong> et le{' '}
		<strong style={{ color: '#212121' }}>cadeau offert</strong> peuvent être différents. Ajoutez chaque
		paire avec le bouton « Ajouter une offre ».
	</Typography>
)

function getInitialRuleFromCampaign(campaign: any, menus: Menu): BogoDiffRuleState {
	const ids = normalizeShopIds(campaign.shopIds)
	const sid = ids[0]
	const offers =
		sid && campaign.config?.products
			? getOffersFromConfig(menus, campaign.config.products, sid)
			: []
	const choosed =
		sid && campaign.config?.products
			? getProductDetailsFromConfig(menus, campaign.config.products, sid, true)
			: []
	return {
		products: campaign.config?.products || [],
		purchasedProducts: choosed,
		selectedProducts: offers,
		disabledPurshasedProducts: [],
		offeredProducts: [],
	}
}

export const buyOneGetOneDifferentProductDefinition: CampaignDefinition<BogoDiffRuleState> = {
	type: CampaignType.BUY_ONE_GET_ONE_DIFFERENT_PRODUCT,
	RuleStep: BogoDiffRuleStep,
	ConfirmationSummary: BogoDiffConfirmationSummary,
	defaultRule: {
		products: [],
		purchasedProducts: [],
		selectedProducts: [],
		disabledPurshasedProducts: [],
		offeredProducts: [],
	},
	validateRule: validateBogoDiffRule,
	buildFormValues: buildBogoDiffFormValues,
	ruleDescription,
	getInitialRuleFromCampaign,
	confirmationLimitPolicy: 'optional',
	showOrderTypesInConfirmation: true,
	forceDeliveryOrderType: false,
	allowsPermanent: true,
}
